import styled from "styled-components";
import { useSelector } from "react-redux";

import * as styles from "styles";
import * as Types from "Types";
import * as grid from "grid";

const Wrap = styled.div<Types.Default>`
   ${styles.Typography.description1}
   ${({ css }) => css}
`;
const WrapXS = styled.div<Types.Default>`
   ${styles.Typography.description1XS}
   ${({ css }) => css}

   overflow-wrap: break-word;
   word-break: keep-all;
`;

export default function Description1(props: Types.Default) {
   const windowWidth = useSelector(({ dimensions }: Types.State) => dimensions.width);
   const shows = grid.shows({
      width: windowWidth,
      grids: { xs: false },
   });

   return shows ? <Wrap {...props}>{props.children}</Wrap> : <WrapXS {...props}>{props.children}</WrapXS>;
}
